import { idField, idFieldRequired } from 'src/lib/ValidatorHelper';
import * as Yup from 'yup';

const AmbassadorValidator = () => Yup.object().shape({
  id: idField(),
  contact_id: idFieldRequired(),
  event_id: idFieldRequired(),
  notify_by_email: Yup.boolean(),
  notify_by_sms: Yup.boolean(),
  invitation_email_sent: Yup.boolean(),
  invitation_sms_sent: Yup.boolean(),
  email: Yup.string().email().required(),
  phone: Yup.string().required(),
  name: Yup.string().required(),
  goal: Yup.string().required().max(128),
  slug: Yup.string().required().max(128),
  message: Yup.string().max(512),
  video_link: Yup.string().max(128),
});

export default AmbassadorValidator;
